import React, { useEffect, useState } from 'react';
import axios from 'axios';
import LandingPage from './LandingPage';
import ShopPublicPage from './ShopPublicPage';
import { useParams } from 'react-router-dom';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
// Default platform hostnames that should always render the landing page.
const PLATFORM_HOSTS = ['photovendo.com', 'www.photovendo.com', 'localhost'];

export default function RootRoute() {
  const [state, setState] = useState({ loading: true, slug: null });

  useEffect(() => {
    const host = (window.location.hostname || '').toLowerCase();
    // Treat preview/staging Emergent hosts, the canonical photovendo.com, and ANY
    // sub-domain of photovendo.com as platform (so admin/superadmin pages work
    // without being routed to a "shop by domain" lookup).
    const isPlatform =
      PLATFORM_HOSTS.includes(host) ||
      host.endsWith('.photovendo.com') ||
      host.endsWith('.emergentagent.com') ||
      host.endsWith('.preview.emergentagent.com');
    if (isPlatform) {
      setState({ loading: false, slug: null });
      return;
    }
    // Otherwise: lookup custom domain → shop slug
    axios.get(`${API}/shop-by-domain`, { params: { host } })
      .then(({ data }) => setState({ loading: false, slug: data?.slug || null }))
      .catch(() => setState({ loading: false, slug: null }));
  }, []);

  if (state.loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FDFBF7]">
        <div className="text-[#877E78] text-sm">Caricamento...</div>
      </div>
    );
  }

  if (state.slug) {
    return <ShopPublicPageWithSlug slug={state.slug} />;
  }
  return <LandingPage />;
}

// Render ShopPublicPage with a hardcoded slug (custom domain case — URL stays at /)
function ShopPublicPageWithSlug({ slug }) {
  // useParams won't work for hardcoded slug → expose via a fake param using React.cloneElement isn't possible here.
  // Easiest: stash slug in window and let ShopPublicPage support either useParams or this fallback.
  return <ShopPublicPage forcedSlug={slug} />;
}
